import React from 'react';
import Bluedots from '../../assets/images/blue_dotes.png'
import feature1a from '../../assets/images/feature1a.png'
import feature1b from '../../assets/images/feature1b.png'
import icon1 from '../../assets/images/feature-icon1.png'
import feature2a from '../../assets/images/feature2a.png'
import feature2b from '../../assets/images/feature2b.png'
import icon2 from '../../assets/images/feature-icon2.png'
import feature3a from '../../assets/images/feature3a.png'
import feature3b from '../../assets/images/feature3b.png'
import icon3 from '../../assets/images/feature-icon3.png'
import Emoji from '../../utils/emoji'


function Hero() {
    return (
        <section className="row_am task_business task_app_section">
            <div className="task_block" style={{ top: 230, position: 'sticky' }}>
                <div className="dotes_blue">
                    <img src={Bluedots} alt="image" />
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="task_img" data-aos="fade-in" data-aos-duration={1500}> 
                            <div className="frame_img">
                                <img src={feature1a} alt="image" />
                            </div>
                            <div className="screen_img">
                                <img className="moving_animation" src={feature1b} alt="image"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="task_text">
                            <div className="section_title white_text" data-aos="fade-up" data-aos-duration={1500} data-aos-delay={100} >
                                <span className="title_badge">LUMO Business</span>
                                <h2>Oferi servicii cu programare? <span style={{fontSize: 2.5 + 'rem'}}>LUMO</span> este pentru tine </h2>
                                <div className='section_text'>
                                    <div className="section_feature">
                                        <p>Fie că ai un salon, ești freelancer sau conduci o afacere locală, LUMO te ajută să atragi clienți noi, să gestionezi programările ușor și să te promovezi profesionist, totul într-un singur loc.</p>
                                    </div>
                                </div>
                                <div class="btn_block">
                                    <a class="btn puprple_btn ml-0" href="/contact">Devino partener <i className="icofont-arrow-right" /></a>
                                    <div class="btn_bottom"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="task_block" style={{ top: 230, position: 'sticky' }}>
                <div className="dotes_blue">
                    <img src={Bluedots} alt="image" />
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="task_img" data-aos="fade-in" data-aos-duration={1500}>
                            <div className="frame_img">
                                <img src={feature2a} alt="image" />
                            </div>
                            <div className="screen_img">
                                <img className="moving_animation" src={feature2b} alt="image" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="task_text">
                            <div className="section_title white_text" data-aos="fade-up" data-aos-duration={1500} data-aos-delay={100} >
                                <span className="title_badge">Unique Features</span>
                                <span className="icon">
                                    <img src={icon2} alt="image" />
                                </span>
                                <h2>Client comunication for best results</h2>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and setting indus
                                    orem Ipsum has been the industrys standard dummxt ever since the
                                    when an own printer took a galley of type and scrambled it to
                                    make. a type specimen book.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="task_block" style={{ top: 230, position: 'sticky' }}>
                <div className="dotes_blue">
                    <img src={Bluedots} alt="image" />
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="task_img" data-aos="fade-in" data-aos-duration={1500}>
                            <div className="frame_img">
                                <img src={feature3a} alt="image" />
                            </div>
                            <div className="screen_img">
                                <img className="moving_animation" src={feature3b} alt="image" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="task_text">
                            <div className="section_title white_text" data-aos="fade-up" data-aos-duration={1500} data-aos-delay={100} >
                                <span className="title_badge">Unique Features</span>
                                <span className="icon">
                                    <img src={icon3} alt="image" />
                                </span>
                                <h2>Live chat with Video Call</h2>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and setting indus
                                    orem Ipsum has been the industrys standard dummxt ever since the
                                    when an own printer took a galley of type and scrambled it to
                                    make. a type specimen book.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            */}
        </section>
    );
}

export default Hero;
